import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppIconComponent } from '../../../lib/ui';

@Component({
  selector: 'app-whats-new-banner',
  standalone: true,
  imports: [CommonModule, AppIconComponent],
  template: `
    <div
      *ngIf="showBanner()"
      class="whats-new-banner fixed top-16 left-0 right-0 z-40 bg-gradient-to-r from-green-500 to-emerald-500 text-white p-4 shadow-lg animate-slide-down"
    >
      <div class="max-w-6xl mx-auto flex items-center justify-between">
        <div class="flex items-center gap-4">
          <div class="flex-shrink-0">
            <app-icon
              name="celebration"
              color=""
              [size]="24"
              class="text-white"
            ></app-icon>
          </div>
          <div>
            <h3 class="font-bold text-lg">🎉 Novidades Incríveis!</h3>
            <p class="text-sm opacity-90">
              Confira o novo <strong>PDV Inovador</strong> com IA, comandos de
              voz e gamificação!
            </p>
          </div>
        </div>

        <div class="flex items-center gap-3">
          <button
            (click)="goToPDV()"
            class="bg-white text-green-600 px-4 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors"
          >
            🚀 Testar Agora
          </button>
          <button
            (click)="closeBanner()"
            class="text-white hover:text-gray-200 transition-colors"
          >
            <app-icon
              name="close"
              color=""
              [size]="20"
              class="text-white"
            ></app-icon>
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .whats-new-banner {
        animation: slideDown 0.5s ease-out;
      }

      @keyframes slideDown {
        from {
          transform: translateY(-100%);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      .animate-slide-down {
        animation: slideDown 0.5s ease-out;
      }
    `,
  ],
})
export class WhatsNewBannerComponent implements OnInit {
  showBanner = signal(false);

  ngOnInit() {
    // Mostrar banner apenas se o usuário não viu as novidades ainda
    const hasSeenNewFeatures = localStorage.getItem(
      'estokai_seen_new_features_june_2025'
    );
    if (!hasSeenNewFeatures) {
      setTimeout(() => this.showBanner.set(true), 1000);
    }
  }

  closeBanner() {
    this.showBanner.set(false);
    localStorage.setItem('estokai_seen_new_features_june_2025', 'true');
  }

  goToPDV() {
    // Navegar para PDV e fechar banner
    window.location.href = '/pdv';
    this.closeBanner();
  }
}
